module.exports = __webpack_public_path__ + "static/media/5f8de7ed5ae7590275f0750d_logo_200x200.7e197b1c.png";